<template>
  <v-container class="px-3 pt-0 pb-0 position-relative">
    <template v-if="categoriesAreWithImage && !smAndDown">
      <div class="d-flex justify-center mt-8">
        <ProductCategoryCard
          v-for="{ id, title, img } in categories"
          :key="id"
          :title="title"
          :img="files + img.featured"
        />
      </div>
    </template>

    <template v-else>
      <div class="d-flex mx-n3 position-relative item-categories">
        <v-slide-group
          v-model="slideGroupModel"
          center-active
          :class="{
            'mx-auto': !smAndDown,
          }"
          mandatory
          :show-arrows="!smAndDown"
        >
          <v-slide-item
            v-for="({ title }, keyCategories) in categories"
            :key="keyCategories"
            v-slot="{ active, toggle }"
          >
            <v-btn
              @click="toggle"
              class="text-body-1 text-none pa-2 position-relative item-category"
              :class="[
                active
                  ? 'primary--text item-category-active'
                  : 'grey--text text--darken-2',

                keyCategories !== 0 ? 'ml-3' : '',
              ]"
              :ripple="false"
              min-width="0"
              color="transparent"
              depressed
              tile
            >
              {{ title }}
            </v-btn>
          </v-slide-item>
        </v-slide-group>
      </div>
    </template>
  </v-container>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import { searchTest } from "../../utils/searchTest";
import ProductCategoryCard from "../cards/ProductCategoryCard.vue";

export default {
  data: () => ({
    slideGroupModel: 0,
    q: "",
  }),
  computed: {
    categoriesWithProducts() {
      const categories = [];
      let items = this.$rest("products").list;
      const search = this.$route.query.q;
      if (search)
        items = items.filter(({ title, text }) => {
          return searchTest(search, title) || searchTest(search, text);
        });
      items.forEach(({ category }) => {
        if (category?.id && !categories.includes(category.id))
          categories.push(category.id);
      });
      return categories;
    },
    categoriesAreWithImage() {
      return this.$rest("categories").list.every(({ img }) => !!img?.featured);
    },
    categories() {
      return this.$rest("categories").list.filter(({ id }) =>
        this.categoriesWithProducts.includes(id)
      );
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    formatToURL,
    scrollTo(id) {
      const headerHeight =
        document.getElementById("header").getBoundingClientRect().height + 20;
      const goTo =
        document.getElementById(id).getBoundingClientRect().top - headerHeight;
      window.scrollBy({ top: goTo, behavior: "smooth" });
    },
  },
  watch: {
    $route() {
      if (this.q && !this.$route.query.q) this.q = "";
    },
    slideGroupModel() {
      this.scrollTo(formatToURL(this.categories[this.slideGroupModel].title));
    },
  },
  components: { ProductCategoryCard },
};
</script>

<style lang="scss" scoped>
.item {
  &-categories {
    &:before {
      background-color: #f1f1f1;
      bottom: 0;
      content: "";
      left: 0;
      height: 1px;
      position: absolute;
      right: 0;
    }
  }

  &-category {
    &:before {
      opacity: 0 !important;
    }

    &:after {
      background-color: transparent;
      bottom: 0;
      content: "";
      height: 1px;
      left: 0;
      position: absolute;
      right: 0;
      transition: all 0.1s linear;
    }

    &-active {
      &:after {
        background-color: var(--v-primary-base);
      }
    }
  }
}
</style>
